// StripePaymentWrapper.jsx
import React, { useEffect, useState } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import StripePayment from "./StripePayment";

// 🔑 Clé publique Stripe (live)
const stripePromise = loadStripe("pk_live_51OMb3MHJRGbXBdcqR4Exd48nNd8ipgl9zyeuollem4Qxu2lMoNso8C5jJljCuvtlU6hSikM0KWYpAT1of5pYbwO200EnHTl5Mx");

export default function StripePaymentWrapper({ cart, user, onSuccess, onError }) {
  const [clientSecret, setClientSecret] = useState("");

  useEffect(() => {
    if (!cart || !cart.total) return;

    // Convertir MAD → USD
    const totalUSD = cart.total / 10;

    const createPaymentIntent = async () => {
      try {
        const response = await fetch(
          "https://d4unaturally.com/api/stripe/create-payment-intent.php",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              amount: Math.round(totalUSD * 100), // USD en cents
              currency: "usd",
              customer_email: user?.email || "",
              items: cart.items || []
            }),
          }
        );

        const data = await response.json();
        if (!data.success) throw new Error(data.message || "Erreur backend");

        setClientSecret(data.data.clientSecret);
      } catch (err) {
        console.error("Erreur createPaymentIntent:", err);
        onError?.("Erreur lors de l'initialisation du paiement");
      }
    };

    createPaymentIntent();
  }, [cart, user, onError]);

  if (!clientSecret) return <p>Chargement du paiement...</p>;

  return (
    <Elements
      stripe={stripePromise}
      options={{ clientSecret, appearance: { theme: "stripe" } ,locale: "en"}}
    >
      <StripePayment clientSecret={clientSecret} cart={cart} onSuccess={onSuccess} onError={onError} />
    </Elements>
  );
}
